/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const lists: Readonly<Record<string, string>> = {
  // Job stages (STAGE_LABEL in packages/core)
  "New Lead": "Nuevo prospecto",
  Contacted: "Contactado",
  "Inspection Scheduled": "Inspección programada",
  Inspected: "Inspeccionado",
  "Proposal Sent": "Propuesta enviada",
  Signed: "Firmado",
  "In Production": "En producción",
  Complete: "Completo",
  Closed: "Cerrado",
  Lost: "Perdido",

  // The rep's pipeline columns (PIPELINE_COLUMNS)
  "New Leads": "Nuevos prospectos",
  Estimating: "Presupuestando",
  "Signed — Needs SENDS": "Firmado — Falta SENDS",
  "Ongoing Jobs": "Trabajos en curso",

  // The production board's columns (PRODUCTION_COLUMN_LABEL)
  "Needs First Payment": "Falta el primer pago",
  "Needs Scheduling": "Falta programar",
  "Active Work": "Trabajo activo",
  "Needs Final Payment": "Falta el pago final",
  "Clean Up": "Limpieza",
  "Closed Won": "Cerrado ganado",

  // Kelsey's close-out board (CLOSEOUT_COLUMNS)
  "Work Complete": "Trabajo completado",
  "Ready to Close": "Listo para cerrar",

  // Checklist steps a card says it is waiting on (outstandingSteps)
  "First Check Submitted": "Primer cheque entregado",
  "First Check": "Primer cheque",
  Permit: "Permiso",
  Material: "Material",
  "All Work Scheduled": "Todo el trabajo programado",
  "All Work Complete": "Todo el trabajo completado",
  "Final Check Submitted": "Cheque final entregado",
  "Final Check": "Cheque final",

  // Payments on a job (PAYMENT_SLOT_LABEL)
  "First Payment": "Primer pago",
  "Second Payment": "Segundo pago",
  "Third Payment": "Tercer pago",
  "Final Payment": "Pago final",

  // Bid types (bidTypeLabel) and a job with no price
  Repair: "Reparación",
  "Replacement · Retail": "Reemplazo · Particular",
  "Replacement · Insurance": "Reemplazo · Seguro",
  "No price yet": "Sin precio aún",

  // A crew's insurance standing (standingWords)
  "has own comp": "tiene su propia compensación laboral",
  "has own liability": "tiene su propia responsabilidad civil",
  "no comp": "sin compensación laboral",
  "no liability": "sin responsabilidad civil",
  "no certificate on file": "sin certificado archivado",

  // Lists
  Staff: "Personal",
  None: "Ninguno",
  "{name} — Pipeline": "{name} — Embudo",
  "Call today": "Llamar hoy",
  "Never called": "Nunca llamado",

  // Ongoing Jobs
  "Loading the board…": "Cargando el tablero…",
  "{amount} owed across 1 job": "{amount} adeudado en 1 trabajo",
  "{amount} owed across {n} jobs": "{amount} adeudado en {n} trabajos",
  ", {amount} on its way": ", {amount} en camino",
  "{n} waiting on payment": "{n} esperando pago",
  "Owes {amount}": "Debe {amount}",
  "+ {amount} on its way": "+ {amount} en camino",
  "+{n} more": "+{n} más",

  // Calendar
  Calendar: "Calendario",
  Today: "Hoy",
  Inspection: "Inspección",
  Work: "Trabajo",
  "Ongoing job": "Trabajo en curso",

  // Close out
  "{name} — Closed": "{name} — Cerrados",
  "{name} — Close Out": "{name} — Cierre",
  "Back to the board": "Volver al tablero",
  "Closed jobs": "Trabajos cerrados",
  someone: "alguien",
  "1 day here": "1 día aquí",
  "{n} days here": "{n} días aquí",
  "Job {number} · {rep}{here}": "Trabajo {number} · {rep}{here}",
  "no rep": "sin vendedor",
  "Sent by {who} on {date}": "Enviado por {who} el {date}",
  "1 thing flagged when sent": "1 cosa señalada al enviar",
  "{n} things flagged when sent": "{n} cosas señaladas al enviar",
  "Closing…": "Cerrando…",
  Close: "Cerrar",
  "No closed jobs": "No hay trabajos cerrados",
  "Sent by {who}, {date}": "Enviado por {who}, {date}",
  "Not sent": "No enviado",
  "Closed by {who}, {date}": "Cerrado por {who}, {date}",
  "Reopening…": "Reabriendo…",
  Reopen: "Reabrir",

  // Money in
  "1 payment from QuickBooks ticked their submitted box":
    "1 pago de QuickBooks marcó su casilla de entregado",
  "{n} payments from QuickBooks ticked their submitted box":
    "{n} pagos de QuickBooks marcaron su casilla de entregado",
  "1 matched to the job QuickBooks had already put it against":
    "1 asignado al trabajo donde QuickBooks ya lo había puesto",
  "{n} matched to the job QuickBooks had already put them against":
    "{n} asignados al trabajo donde QuickBooks ya los había puesto",
  "{n} matched to the payment request the customer paid":
    "{n} asignados a la solicitud de pago que pagó el cliente",
  "1 card payment taken out of a Stripe payout":
    "1 pago con tarjeta separado de un depósito de Stripe",
  "{n} card payments taken out of a Stripe payout":
    "{n} pagos con tarjeta separados de un depósito de Stripe",
  "{n} set aside as not a customer payment":
    "{n} apartados por no ser pago de un cliente",
  "Put back. It is in the list above, waiting to be matched.":
    "Devuelto. Está en la lista de arriba, esperando ser asignado.",
  "Money in": "Dinero recibido",
  waiting: "esperando",
  "Card payouts waiting: {list}": "Depósitos de tarjeta pendientes: {list}",
  "Nothing waiting to be matched.": "Nada esperando ser asignado.",
  "These landed in the Mercury account. Say which job each one belongs to and Roof Board ticks that job’s payment box — it will not guess.":
    "Esto llegó a la cuenta de Mercury. Indica a qué trabajo pertenece cada uno y Roof Board marca la casilla de pago de ese trabajo — no adivina.",
  "Ticked {boxes}. {why}": "Se marcó {boxes}. {why}",
  "Recorded against the job. {why} No payment box was ticked.":
    "Registrado en el trabajo. {why} No se marcó ninguna casilla de pago.",
  "The receipt is filed on the job, and nobody is being asked to send it.":
    "El recibo queda archivado en el trabajo y no se pide a nadie que lo envíe.",
  "Split into {n} payments. {recorded} recorded":
    "Dividido en {n} pagos. {recorded} registrados",
  "; 1 could not be and is back on this list: {list}":
    "; 1 no se pudo y volvió a esta lista: {list}",
  "; {n} could not be and are back on this list: {list}":
    "; {n} no se pudieron y volvieron a esta lista: {list}",
  "Set this deposit aside. What is it?": "Apartar este depósito. ¿Qué es?",
  "What was set aside automatically": "Lo que se apartó automáticamente",
  "Looking…": "Buscando…",
  "Nothing has been set aside automatically. Roof Board learns a payer once somebody has set it aside twice.":
    "No se ha apartado nada automáticamente. Roof Board aprende un pagador cuando alguien lo ha apartado dos veces.",
  "Put it back": "Devolver",
  and: "y",
  pending: "pendiente",
  "No description on the bank line.": "Sin descripción en la línea del banco.",
  "Looks like a payment request": "Parece una solicitud de pago",
  "Probably this customer": "Probablemente este cliente",
  "Matches a payment": "Coincide con un pago",
  "Needs a person": "Necesita una persona",
  "Send this customer a receipt": "Enviar un recibo a este cliente",
  "Yes, that payment": "Sí, ese pago",
  "Yes, that job": "Sí, ese trabajo",
  "Find the job": "Buscar el trabajo",
  "A different job": "Otro trabajo",
  "Not a split": "No dividir",
  "More than one payment": "Más de un pago",
  "Not a customer": "No es un cliente",
  "No signed job is waiting for money. This may be a refund, a transfer, or a job that has not been signed in Roof Board yet.":
    "Ningún trabajo firmado espera dinero. Puede ser un reembolso, una transferencia o un trabajo que aún no se ha firmado en Roof Board.",
  "Search a customer, job number or address…":
    "Buscar cliente, número de trabajo o dirección…",
  "Nobody signed matches that. A job that is paid in full is not on this list.":
    "Ningún cliente firmado coincide. Un trabajo pagado por completo no está en esta lista.",
  "1 more signed customer — search above to find them.":
    "1 cliente firmado más — búscalo arriba.",
  "{n} more signed customers — search above to find them.":
    "{n} clientes firmados más — búscalos arriba.",
  "Stripe pays out in batches, so one bank line can be several customers. Type what each customer paid — the figure beside their name on the Stripe payout, before Stripe’s fee. Roof Board takes the fee off and counts the {amount} down to nothing.":
    "Stripe deposita en lotes, así que una línea del banco puede ser de varios clientes. Escribe lo que pagó cada cliente — la cifra junto a su nombre en el depósito de Stripe, antes de la comisión de Stripe. Roof Board resta la comisión y descuenta los {amount} hasta cero.",
  "Which customer?": "¿Qué cliente?",
  "Which payment this settles": "Qué pago cubre esto",
  "Choose the customer first — the payments are theirs.":
    "Elige primero el cliente — los pagos son suyos.",
  "Work it out": "Calcularlo",
  "— the rest": "— el resto",
  "What they paid": "Lo que pagaron",
  "less {fee} fee = {net} in the bank":
    "menos {fee} de comisión = {net} en el banco",
  "A split needs at least two payments.":
    "Una división necesita al menos dos pagos.",
  "Take this one off the split": "Quitar este de la división",
  "Another customer": "Otro cliente",
  "Balances to {amount}.": "Cuadra en {amount}.",
  "Record {n} payments": "Registrar {n} pagos",
  Cancel: "Cancelar",
  "{label} on this job. No box on the checklist covers the middle payments, so none is ticked.":
    "{label} de este trabajo. Ninguna casilla de la lista cubre los pagos intermedios, así que no se marca ninguna.",
  "Tick this job's payment box": "Marcar la casilla de pago de este trabajo",
  "Record it against this job as the {label}. The middle payments have no box, so none is ticked.":
    "Registrarlo en este trabajo como {label}. Los pagos intermedios no tienen casilla, así que no se marca ninguna.",
  "Record it against this job. The amount fits no scheduled payment, so no box is ticked.":
    "Registrarlo en este trabajo. El monto no coincide con ningún pago programado, así que no se marca ninguna casilla.",
  "This one": "Este",
  "Record as the {label}": "Registrar como {label}",
  "Record it anyway": "Registrarlo de todos modos",

  // Insurance owed
  "Working out insurance…": "Calculando el seguro…",
  "Insurance owed": "Seguro adeudado",
  "Workers comp and general liability on the crews paid each month, by the day each crew was paid. A crew with its own current certificate costs no comp and ${rate} per $1,000 of liability; everyone else is charged the full rate for the trade. Certificates are read as they stand today.":
    "Compensación laboral y responsabilidad civil sobre las cuadrillas pagadas cada mes, según el día en que se pagó a cada cuadrilla. Una cuadrilla con su propio certificado vigente no cuesta compensación y cuesta ${rate} por cada $1,000 de responsabilidad; a las demás se les cobra la tarifa completa del oficio. Los certificados se leen como están hoy.",
  "No crew has been marked paid yet.":
    "Todavía no se ha marcado ninguna cuadrilla como pagada.",
  Month: "Mes",
  "Paid to crews": "Pagado a cuadrillas",
  "With own comp": "Con compensación propia",
  "Without comp": "Sin compensación",
  "Comp owed": "Compensación adeudada",
  "With own liability": "Con responsabilidad propia",
  "Without liability": "Sin responsabilidad",
  Liability: "Responsabilidad civil",
  "paid {amount}": "pagado {amount}",
  "comp {amount}": "compensación {amount}",
  "liability {amount}": "responsabilidad {amount}",
  "paid {date}": "pagado el {date}",
  "Liability policy year": "Año de la póliza de responsabilidad",
  to: "al",
  "paid to crews {paid} ({own} with their own liability), liability {owed}":
    "pagado a cuadrillas {paid} ({own} con su propia responsabilidad), responsabilidad {owed}",
  ", on pace for {amount}": ", al ritmo de {amount}",

  // Master — sold jobs
  "Master — Sold Jobs": "Maestro — Trabajos vendidos",
  "No sold jobs match the current filters.":
    "Ningún trabajo vendido coincide con los filtros.",
  Revenue: "Ingresos",
  "What it cost": "Lo que costó",
  "Gross profit": "Ganancia bruta",
  Margin: "Margen",
  "Under {pct}%": "Menos de {pct}%",
  "Average job": "Trabajo promedio",
  "Couldn't load closing %.": "No se pudo cargar el % de cierre.",
  "No estimates were sent in this period.":
    "No se enviaron presupuestos en este periodo.",
  "Closing %": "% de cierre",
  "{closed} of {sent} estimates sent":
    "{closed} de {sent} presupuestos enviados",
  "{closed} of {sent}": "{closed} de {sent}",

  // The unclaimed new-lead bucket
  "Make a lead": "Crear un prospecto",
  "A new contact and a job at New Lead for":
    "Un contacto nuevo y un trabajo en Nuevo prospecto para",
  ", from {source}": ", de {source}",
  "Everything they have already sent moves onto it.":
    "Todo lo que ya enviaron pasa a él.",
  "Their name": "Su nombre",
  "Leave it blank if you do not know it yet.":
    "Déjalo en blanco si aún no lo sabes.",
  "Making…": "Creando…",
  "Make the lead": "Crear el prospecto",
  "1 call": "1 llamada",
  "{n} calls": "{n} llamadas",
  "1 voicemail": "1 mensaje de voz",
  "{n} voicemails": "{n} mensajes de voz",
  "1 text": "1 mensaje",
  "{n} texts": "{n} mensajes",
  "New — nobody we know": "Nuevo — nadie conocido",
  "No source": "Sin fuente",

  // Crew payouts
  "QuickBooks already has the bill for WO-{number} ({amount}).":
    "QuickBooks ya tiene la factura de WO-{number} ({amount}).",
  "Undo takes the approval back. Approve it again and QuickBooks gets the new amount on the same bill. If it is not approved again, the bill stays in QuickBooks until somebody voids it there.":
    "Deshacer retira la aprobación. Si se aprueba de nuevo, QuickBooks recibe el nuevo monto en la misma factura. Si no se vuelve a aprobar, la factura queda en QuickBooks hasta que alguien la anule allí.",
  "Mark all {n} approved payouts as paid, totalling {amount}? Do this once the money has actually gone out of Mercury.":
    "¿Marcar los {n} pagos aprobados como pagados, por un total de {amount}? Hazlo cuando el dinero ya haya salido de Mercury.",
  "Nothing here.": "Nada aquí.",
  "Work order": "Orden de trabajo",
  Crew: "Cuadrilla",
  Job: "Trabajo",
  Completed: "Completado",
  Amount: "Monto",
  partial: "parcial",
  Approve: "Aprobar",
  "Change amount": "Cambiar monto",
  Reject: "Rechazar",
  "Already paid": "Ya pagado",
  Hold: "Retener",
  "Mark paid": "Marcar pagado",
  Undo: "Deshacer",
  "paid before review": "pagado antes de revisar",
  "Not paid": "No pagado",
  "Approve now": "Aprobar ahora",
  "Back to review": "Volver a revisión",
  "Crew Payouts": "Pagos a cuadrillas",
  "{amount} approved": "{amount} aprobado",
  "This run covers work completed before midnight on {date}. Our own crews are not here — they are on payroll, not a bill.":
    "Este lote cubre el trabajo completado antes de la medianoche del {date}. Nuestras propias cuadrillas no aparecen aquí — están en nómina, no en factura.",
  "Needs review": "Falta revisar",
  "Completed before the cutoff. Approve, change the amount, or send it back.":
    "Completado antes del corte. Aprueba, cambia el monto o devuélvelo.",
  "Finished after the cutoff": "Terminado después del corte",
  "Not due until next Thursday — approve one anyway if it should go out today.":
    "No vence hasta el próximo jueves — apruébalo de todos modos si debe salir hoy.",
  "Approved, to pay": "Aprobado, por pagar",
  "These are Thursday's ACH. QuickBooks already has the cost — mark each one paid once the money has gone, or use the button above. Marking one paid also ticks Crew paid on its work order.":
    "Este es el ACH del jueves. QuickBooks ya tiene el costo — marca cada uno como pagado cuando el dinero haya salido, o usa el botón de arriba. Marcar uno como pagado también marca Cuadrilla pagada en su orden de trabajo.",
  "Mark all paid": "Marcar todos pagados",
  Paid: "Pagado",
  "The money has gone. These drop off the board after {days} days; the work order still shows the payout.":
    "El dinero ya salió. Estos desaparecen del tablero después de {days} días; la orden de trabajo sigue mostrando el pago.",
  "On hold": "Retenido",
  "Still owed, but waiting on something — a W-9, bank details, or a decision. Approve now once it is sorted, or put it back in review.":
    "Se sigue debiendo, pero espera algo — un W-9, datos bancarios o una decisión. Aprueba ahora cuando se resuelva, o devuélvelo a revisión.",
  "Sent back": "Devuelto",
  "Rejected with a note. These come back once the crew has sorted it.":
    "Rechazado con una nota. Vuelven cuando la cuadrilla lo haya resuelto.",
  "Approve WO-{number} for a different amount":
    "Aprobar WO-{number} por otro monto",
  "Use this when the crew did not finish everything. The amount here replaces the order total for payment; the work order itself is unchanged.":
    "Usa esto cuando la cuadrilla no terminó todo. Este monto reemplaza el total de la orden para el pago; la orden de trabajo no cambia.",
  "Approve this amount": "Aprobar este monto",
  "Amount to pay": "Monto a pagar",
  "Order total is {amount}.": "El total de la orden es {amount}.",
  "WO-{number} has already been paid": "WO-{number} ya se pagó",
  "Use this when the crew was paid by hand, straight out of Mercury. It leaves the Thursday run — nothing is sent for it — and the cost still goes to QuickBooks, where the Mercury payment matches against it.":
    "Usa esto cuando a la cuadrilla se le pagó a mano, directo desde Mercury. Sale del lote del jueves — no se envía nada por él — y el costo igual va a QuickBooks, donde se cruza con el pago de Mercury.",
  "Mark as paid": "Marcar como pagado",
  "Amount that was paid": "Monto que se pagó",
  "Send WO-{number} back": "Devolver WO-{number}",
  "It leaves this run and waits. Say why, so the crew knows what to fix.":
    "Sale de este lote y espera. Di por qué, para que la cuadrilla sepa qué corregir.",
  "Send back": "Devolver",
  Reason: "Motivo",
  "What needs sorting before this is paid":
    "Qué hay que resolver antes de pagarlo",
  "Marked complete {when}.": "Marcado como completo {when}.",
  "by {who}": "por {who}",
  "On hold {said}": "Retenido {said}",
  "Put WO-{number} on hold": "Retener WO-{number}",
  "It is still owed, but it cannot be paid yet. It leaves this list and waits under On hold with the reason, until you approve it or put it back.":
    "Se sigue debiendo, pero aún no se puede pagar. Sale de esta lista y espera en Retenido con el motivo, hasta que lo apruebes o lo devuelvas.",
  "Put on hold": "Retener",
  "Missing W-9, no bank details, placeholder order…":
    "Falta W-9, sin datos bancarios, orden provisional…",
};
